import {ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, input, OnInit} from '@angular/core';
import {ResearchPaperDTO, ScreeningResultDTO} from '../../dto/research-paper';
import {MatIconModule} from '@angular/material/icon';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatButtonModule} from '@angular/material/button';
import {Store} from '@ngrx/store';
import {updateScreeningResearchPaper} from '../../services/research-paper/research-paper.actions';
import {NgClass} from '@angular/common';

@Component({
  selector: 'app-screening-criterias-results',
  imports: [
    MatIconModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    MatSlideToggleModule,
    MatButtonModule,
    NgClass
  ],
  templateUrl: './screening-criterias-results.component.html',
  styleUrl: './screening-criterias-results.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ScreeningCriteriasResultsComponent implements OnInit {
  private readonly store: Store = inject(Store);
  private readonly cdr: ChangeDetectorRef = inject(ChangeDetectorRef);
  readonly isScreeningOne = input<boolean>(false);
  readonly runId = input.required<number>();
  readonly paper = input.required<ResearchPaperDTO>();
  readonly results = input<ScreeningResultDTO[]>();
  readonly editable = input<boolean>(false);


  screeningResult?: ScreeningResultDTO[];
  editMode?: number;

  override: boolean = true;
  reason = '';

  ngOnInit() {
    this.screeningResult = this.results();
  }

  isPassed(result: ScreeningResultDTO): boolean {
    if (result.manuelOverride) {
      return !result.passed;
    }
    return result.passed;
  }

  editItem(index: number): void {
    if (!this.editable()) {
      return;
    }
    if (!this.screeningResult) {
      return;
    }
    if (this.editMode === index) {
      this.editMode = undefined;
      return;
    }
    this.editMode = index;
    this.prepareForm();
  }

  prepareForm(): void {
    this.override = true;
    this.reason = '';
  }

  disableSave(): boolean {
    return this.override && this.reason === '';
  }

  save() {
    if (this.editMode === undefined) {
      return;
    }
    if (!this.runId()) {
      return;
    }
    const result = {
      ...this.screeningResult![this.editMode],
      manuelOverride: this.override,
      manuelReason: this.reason
    }
    this.store.dispatch(updateScreeningResearchPaper({
      projectId: this.paper().projectId,
      runId: this.runId()!,
      paperId: this.paper().id,
      screeningOne: this.isScreeningOne(),
      screeningResult: result
    }));
    this.screeningResult = [
      ...this.screeningResult!.slice(0, this.editMode),
      result,
      ...this.screeningResult!.slice(this.editMode + 1)
    ];
    this.editItem(this.editMode);
  }
}
